module.exports = __webpack_public_path__ + "static/media/Stage-c-f.9a2cd03d.webp";